export const typeList = [
  "stress",
  "mute",
  "multi-tone",
  "liandu",
  "localSpeed",
  "globalMute",
  "multiSpeaker"
]
export const typeShowObj = {
  stress: "showStress",
  liandu: "showLiandu",
  globalMute: "showGlobalMuteSheet",
  localSpeed: "showLocalSpeed",
  multiSpeaker: "showMultiSpeaker",
  mute: "showMute",
  "multi-tone": "showMutilTone",
  pause: "showPause",
}
export const nestableEffectId = {
  'liandu': "continuousid", // ����
  'localSpeed': "speedHover", // �ֲ�����
  'multiSpeaker': "hover", //�෢����
  'aliasChange': "aliasGroupKey", //����
  'phonetics': "phoneticsid",
};